import { field } from '../../core/field-schema';
import { required } from '../../core/validator-builders';
import { SelectField } from '../../models/field-models';
import { FlexBasicInfoFieldId } from './base-config-models';
import { FlexScanModeOption, FlexScanModeValue } from './models';

export const FLEX_SCAN_MODE_OPTIONS: FlexScanModeOption[] = [
    { id: FlexScanModeValue.Normal, value: FlexScanModeValue.Normal, text: 'Normal' },
    { id: FlexScanModeValue.Fast, value: FlexScanModeValue.Fast, text: 'Fast' },
];

export function createFlexScanModeField(
    scanMode: FlexScanModeValue,
    disabled: boolean,
): SelectField<FlexScanModeOption, FlexScanModeValue> {
    return field.select<FlexScanModeOption, FlexScanModeValue>(FlexBasicInfoFieldId.ScanMode, 'scanMode', {
        value: disabled ? FlexScanModeValue.Normal : scanMode,
        disabled,
        panelClass: 'custom-width',
        placeholder: 'ADD_EDIT.INPUT_PLACEHOLDER_SCAN_RATE',
        validators: [required()],
        optionsSelector: FLEX_SCAN_MODE_OPTIONS,
        valueMapper: (option) => option.value,
        displayMapper: (option) => option.text,
    });
}

export function resolveFlexScanMode(scanMode: FlexScanModeValue | null | undefined): FlexScanModeValue {
    return scanMode === FlexScanModeValue.Fast ? FlexScanModeValue.Fast : FlexScanModeValue.Normal;
}

export function shouldLockFlexScanRate(
    normalStorageInterval: number | null | undefined,
    fastStorageInterval: number | null | undefined,
): boolean {
    return (
        normalStorageInterval != null && fastStorageInterval != null && normalStorageInterval === fastStorageInterval
    );
}

export function resolveFlexScanModeForIntervals(
    scanMode: FlexScanModeValue | null | undefined,
    normalStorageInterval: number,
    fastStorageInterval: number,
): FlexScanModeValue {
    return shouldLockFlexScanRate(normalStorageInterval, fastStorageInterval)
        ? FlexScanModeValue.Normal
        : resolveFlexScanMode(scanMode);
}
